module.exports = __webpack_public_path__ + "static/media/icon-Policard.21db7ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Policard.svg
// module id = 2905
// module chunks = 0